import React from "react";
import LogsTable from "./LogsTable";

// No filters on this page: the table takes the whole width
const LogsContainer: React.FC = () => (
  <div className="lp-layout filters-hidden">
    <LogsTable/>
  </div>
);

export default LogsContainer;
